<template>
    <div>
        <template v-if="party.user">
            <v-icon left small>mdi-account</v-icon> {{ party.user.firstname }} {{ party.user.lastname }}
        </template>
        <template v-else-if="party.customer">
            <router-link :to="'/customer/' + party.customer.id ">{{ party.customer.firstname }} {{ party.customer.lastname }}</router-link> - {{ party.phone_number | phone }}
            <template v-if="party.simular_customers && party.simular_customers.length > 1">
                <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                        <v-icon
                            color="secondary"
                            dark
                            v-bind="attrs"
                            v-on="on"
                        >
                            mdi-information-outline
                        </v-icon>
                    </template>
                    <span>{{party.simular_customers.length}} klanten gevonden met dit nummer</span>
                </v-tooltip>
            </template>
        </template>
        <template v-else>
            {{ party.phone_number }}
        </template>
    </div>
</template>

<script>
    export default {
        props: {
            party: {
                required: true,
            }
        }
    }
</script>
